import { takeLatest, all, put, call, select } from "redux-saga/effects";
import buyApproveService from "../../services/buyApprove.service";
import {
  fetchBuyApproveData,
  deleteBuyApprove,
  buyApproveFetchFailed,
  buyApproveFetchSuccess,
  deleteBuyApproveFailed,
  deleteBuyApproveSuccess,
  resetPasswordFailed,
  resetPasswordSuccess,
  initiateResetPassword,
  buyApproveAdded,
  buyApproveUpdated,
} from "../../features/buyApprove/buyApproveSlice";
import PartnerApi from "../../helpers/PartnerApi";
import { error, success } from "../../features/toast/toastSlice";
import { SUCCESS_PASSWORD_RESET_MAIL, DELETED } from "../../data/message";

const handleQueryData = (queryData) => {
  const { filter } = queryData;
  const params = {};

  if (filter?.resellerId) {
    params.resellerId = filter.resellerId;
  } else {
    throw new Error("resellerId zorunlu parametredir!");
  }

  if (filter?.owner) {
    params.owner = filter.owner;
  }

  return params;
};

export function* fetchBuyApproves(action) {
  try {
    const postData = handleQueryData(action.payload);
    const response = yield call(buyApproveService.buyApprovesList, postData);

    const list = (response?.data?.licenseToBeApprovedList ?? []).map(item => ({
      ...item,
      id: item.licenseId,
    }));

    // Eğer paging bilgisi yoksa total = list.length
    const totalResults = response?.data?.paging?.totalResults ?? list.length;

    yield put(
      buyApproveFetchSuccess({
        data: list,
        total: totalResults,
      })
    );
  } catch (err) {
    yield put(
      buyApproveFetchFailed({
        message: err?.message || "Bir hata oluştu",
      })
    );
  }
}

function* deleteBuyApproveData(action) {
  try {
    let id = action.payload;
    yield call(buyApproveService.deleteBuyApprove, id);
    reInitiateBuyApproveList();
    yield put({
      type: success.toString(),
      payload: { message: DELETED, delay: 5000 },
    });
    yield put({ type: deleteBuyApproveSuccess.toString(), payload: id });
  } catch (err) {
    let { message } = err;
    if (message === "Database Error") {
      message = "Some error occured.";
    }
    yield put({ type: error.toString(), payload: { message, delay: 3000 } });
    yield put({ type: deleteBuyApproveFailed.toString(), payload: message });
  }
}

function* reInitiateBuyApproveList() {
  const queryData = yield select((state) => state.BuyApprove.queryData);
  yield put({ type: fetchBuyApproveData.toString(), payload: queryData });
}

function* makeResetPasswordRequest(action) {
  try {
    let { data, selectedBuyApproves } = yield select((state) => state.BuyApprove);
    let ids = Object.keys(selectedBuyApproves);
    let currentId = parseInt(ids[0]);
    let { email } = data.find((c) => c.id === currentId);

    yield call(buyApproveService.resetPassword, { email });
    yield put({
      type: success.toString(),
      payload: { message: SUCCESS_PASSWORD_RESET_MAIL, delay: 3000 },
    });
    yield put({
      type: resetPasswordSuccess.toString(),
      payload: SUCCESS_PASSWORD_RESET_MAIL,
    });
  } catch (err) {
    let { message } = err;
    yield put({ type: error.toString(), payload: { message, delay: 3000 } });
    yield put({ type: resetPasswordFailed.toString(), payload: message });
  }
}

function* watchListRequest() {
  yield takeLatest(fetchBuyApproveData.toString(), fetchBuyApproves);
}

function* watchDeleteRequest() {
  yield takeLatest(deleteBuyApprove.toString(), deleteBuyApproveData);
}

function* watchResetPasswordRequest() {
  yield takeLatest(initiateResetPassword.toString(), makeResetPasswordRequest);
}

function* watchBuyApproveUpdated() {
  yield takeLatest(buyApproveUpdated.toString(), reInitiateBuyApproveList);
}

function* watchBuyApproveAdded() {
  yield takeLatest(buyApproveAdded.toString(), reInitiateBuyApproveList);
}

export function* fetchSpecialCaseRecord(action) {
  try {
    const postData = handleQueryData(action.payload);
    const response = yield call(PartnerApi.postSpecialCaseRecord, postData);

    const list = (response?.data?.postSpecialCaseRecord ?? []).map(item => ({
      ...item,
      id: item.licenseId,
    }));

    const totalResults = response?.data?.paging?.totalResults ?? list.length;

    yield put(
      buyApproveFetchSuccess({
        data: list,
        total: totalResults,
      })
    );
  } catch (err) {
    yield put(
      buyApproveFetchFailed({
        message: err?.message || "Bir hata oluştu",
      })
    );
  }
}


export default function* buyApproveSearchSaga() {
  yield all([
    watchListRequest(),
    watchDeleteRequest(),
    watchResetPasswordRequest(),
    watchBuyApproveAdded(),
    watchBuyApproveUpdated(),
  ]);
}
